/* globals alert */

import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { apiPost } from '../brainApi';
import { getServiceEntity } from '../helper';

export default class CopyBookingDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: '',
    };

    this.onCloseClear = this.onCloseClear.bind(this);
    this.createBooking = this.createBooking.bind(this);
  }

  onCloseClear() {
    const { onClose } = this.props;
    onClose();
    this.clearState();
  }

  createBooking() {
    const { date } = this.state;
    const { scheduleInstance, updateCalendar } = this.props;
    scheduleInstance.start_time = `${date} 00:00:00`;
    scheduleInstance.end_time = `${date} 00:00:00`;
    scheduleInstance.client_location_ids = scheduleInstance.client_locations.map(
      (cl) => cl.client_location_id,
    );

    return apiPost('/schedule', scheduleInstance).then((json) => {
      if (json.Status === 'Failure') {
        alert(`Error:\n\n${json.Message}`);
      } else {
        this.clearState();
        updateCalendar(json);
        this.onCloseClear();
        return;
      }

      if (json.Status === 'Failure') {
        alert(`Error:\n\n${json.Message}`);
      } else {
        alert(`Unknown Error:\n\n${JSON.stringify(json)}`);
      }
    });
  }

  clearState() {
    this.setState({ date: '' });
  }

  renderScheduleFields = (si) => {
    const { allServiceVehicles } = this.props;
    const serviceVehicle = allServiceVehicles.find(
      ({ id }) => id === si.service_vehicle_id,
    );
    return (
      <div>
        <strong>{getServiceEntity()}: </strong>
        {serviceVehicle.name}
        <br />
        <strong>Service Types: </strong>
        {si.offered_service_types}
        <br />
        <strong>Limits: </strong>
        {si.limit_total_hours} hours, {si.limit_scheduled_works} bookings
        <br />
        <strong>Demand Based: </strong>
        {si.is_demand_based ? 'True' : 'False'}
        <br />
        <strong>Client Locations:</strong>
        <ul>
          {si.client_locations.map((cl) => (
            <li key={cl.client_location_id}>{cl.short_name}</li>
          ))}
        </ul>
      </div>
    );
  };

  // service_vehicle_id: serviceVehicleId,
  //   client_location_ids: clientLocationIds,
  //   start_time: `${date} 00:00:00`,
  //   end_time: `${date} 00:00:00`,
  //   offered_service_types: selectedServiceTypes,
  //   created_by: 'Brain2 Admin',
  //   is_canceled: false,
  //   internal_note: 'Brain2 Admin',
  //   limit_total_hours: limitTotalHours,
  //   limit_scheduled_works: limitScheduledWorks,
  //   is_demand_based: isDemandBased,

  render() {
    const { scheduleInstance, open } = this.props;
    const { date } = this.state;

    return (
      <Dialog
        open={open}
        onClose={this.onCloseClear}
        aria-labelledby="form-dialog-title"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">Copy Booking Date</DialogTitle>
        <DialogContent>
          <TextField
            id="date"
            type="date"
            value={date}
            onChange={(e) => this.setState({ date: e.target.value })}
            fullWidth
          />
          {scheduleInstance && this.renderScheduleFields(scheduleInstance)}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.onCloseClear} color="primary">
            Cancel
          </Button>
          <Button
            onClick={this.createBooking}
            color="primary"
            variant="contained"
            disabled={!date}
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
